/**
 * @generated SignedSource<<d05a8ba9c77e2e064447644a1a5e1246>>
 * @relayHash 6b0fcb80825594073476542b68c3affb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID eb3975c138031e239b7a430ede7d396c26f2052d31602e86bb2648a26245f296

import type { ConcreteRequest } from 'relay-runtime';
export type useStatusUpdatesAutomationNudgeActionQuery$variables = {
  contentId: string;
};
export type useStatusUpdatesAutomationNudgeActionQuery$data = {
  readonly singleContent: {
    readonly ancestors: ReadonlyArray<{
      readonly id: string | null;
      readonly title: string | null;
    } | null> | null;
    readonly children: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly metadata: {
          readonly createdDate: string | null;
        };
        readonly title: string | null;
      } | null> | null;
    } | null;
    readonly history: {
      readonly ownedBy: {
        readonly accountId?: string | null;
      } | null;
    } | null;
    readonly id: string | null;
    readonly metadata: {
      readonly sourceTemplateEntityId: string | null;
    };
    readonly space: {
      readonly id: string | null;
    } | null;
    readonly title: string | null;
  } | null;
  readonly user: {
    readonly emails: ReadonlyArray<{
      readonly isPrimary: boolean | null;
      readonly value: string | null;
    } | null> | null;
    readonly id: string | null;
  } | null;
};
export type useStatusUpdatesAutomationNudgeActionQuery = {
  response: useStatusUpdatesAutomationNudgeActionQuery$data;
  variables: useStatusUpdatesAutomationNudgeActionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "alias": "user",
  "args": [
    {
      "kind": "Literal",
      "name": "current",
      "value": true
    }
  ],
  "concreteType": "AtlassianUser",
  "kind": "LinkedField",
  "name": "confluence_atlassianUser",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "concreteType": "AtlassianUserEmail",
      "kind": "LinkedField",
      "name": "emails",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "value"
        },
        {
          "kind": "ScalarField",
          "name": "isPrimary"
        }
      ]
    }
  ],
  "storageKey": "confluence_atlassianUser(current:true)"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "title"
},
v5 = {
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v1/*: any*/)
  ]
},
v6 = {
  "concreteType": "Content",
  "kind": "LinkedField",
  "name": "ancestors",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    (v4/*: any*/)
  ]
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v8 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "sourceTemplateEntityId"
    }
  ]
},
v9 = {
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 25
    }
  ],
  "concreteType": "PaginatedContentList",
  "kind": "LinkedField",
  "name": "children",
  "plural": false,
  "selections": [
    {
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        (v4/*: any*/),
        {
          "concreteType": "ContentMetadata",
          "kind": "LinkedField",
          "name": "metadata",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "createdDate"
            }
          ]
        }
      ]
    }
  ],
  "storageKey": "children(first:25)"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useStatusUpdatesAutomationNudgeActionQuery",
    "selections": [
      (v2/*: any*/),
      {
        "args": (v3/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "concreteType": "History",
            "kind": "LinkedField",
            "name": "history",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "ownedBy",
                "plural": false,
                "selections": [
                  (v7/*: any*/)
                ]
              }
            ]
          },
          (v8/*: any*/),
          (v9/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useStatusUpdatesAutomationNudgeActionQuery",
    "selections": [
      (v2/*: any*/),
      {
        "args": (v3/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "concreteType": "History",
            "kind": "LinkedField",
            "name": "history",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "ownedBy",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v7/*: any*/)
                ]
              }
            ]
          },
          (v8/*: any*/),
          (v9/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "6b0fcb80825594073476542b68c3affb",
    "id": "eb3975c138031e239b7a430ede7d396c26f2052d31602e86bb2648a26245f296",
    "metadata": {},
    "name": "useStatusUpdatesAutomationNudgeActionQuery",
    "operationKind": "query",
    "text": "query useStatusUpdatesAutomationNudgeActionQuery($contentId:ID!){user:confluence_atlassianUser(current:true){id,emails{value,isPrimary}},singleContent(id:$contentId){id,title,space{id},ancestors{id,title},history{ownedBy{__typename,...on KnownUser{accountId}}},metadata{sourceTemplateEntityId},children(first:25){nodes{id,title,metadata{createdDate}}}}}"
  }
};
})();

(node as any).hash = "51dcd0fd9132d4d5024f9afe646cbede";

export default node;
